import { withFlexProps } from '@hocs';
import { Flex, Typography } from '@styles';
import { bool, string } from 'prop-types';
import React from 'react';

import theme from '../../styles/theme';

const ShadowedCard = ({ text, withBottomOffset }) => (
  <Flex height="95px" position="relative" width="310px">
    <Flex
      alignItems="center"
      backgroundColor={theme.colors.schoolBusYellow}
      bottom="6px"
      flexDirection="column"
      height="95px"
      justifyContent="center"
      position="absolute"
      right="6px"
      width="310px"
      zIndex={3}
    >
      <Typography color="black" variant="BN-bold-s64-lh55">
        {text}
      </Typography>
      {withBottomOffset && <Flex height="130px" />}
    </Flex>
    <Flex
      background={theme.colors.black[100]}
      height="95px"
      width="310px"
      zIndex={0}
    />
  </Flex>
);

ShadowedCard.propTypes = {
  text: string.isRequired,
  withBottomOffset: bool,
};

ShadowedCard.defaultProps = {
  withBottomOffset: false,
};

export default withFlexProps(ShadowedCard);
